var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 20.0002H5.1C4.69 20.0002 4.35 19.6602 4.35 19.2502C4.35 18.8402 4.69 18.5002 5.1 18.5002H16.9C17.91 18.5002 18.25 18.2902 18.25 17.0202V15.9802C18.25 14.7102 17.91 14.5002 16.9 14.5002H5.1C4.69 14.5002 4.35 14.1602 4.35 13.7502C4.35 13.3402 4.69 13.0002 5.1 13.0002H16.9C18.82 13.0002 19.75 13.9802 19.75 15.9802V17.0202C19.75 19.0202 18.82 20.0002 16.9 20.0002Z",
    fill: "#0C1525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 11.5002H5.1C4.69 11.5002 4.35 11.1602 4.35 10.7502C4.35 10.3402 4.69 10.0002 5.1 10.0002H11.9C12.91 10.0002 13.25 9.79024 13.25 8.52024V7.48023C13.25 6.21023 12.91 6.00023 11.9 6.00023H5.1C4.69 6.00023 4.35 5.66023 4.35 5.25023C4.35 4.84023 4.69 4.50023 5.1 4.50023H11.9C13.82 4.50023 14.75 5.48023 14.75 7.48023V8.52024C14.75 10.5202 13.82 11.5002 11.9 11.5002Z",
    fill: "#0C1525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22.7402C4.59 22.7402 4.25 22.4002 4.25 21.9902V1.99023C4.25 1.58023 4.59 1.24023 5 1.24023C5.41 1.24023 5.75 1.58023 5.75 1.99023V21.9902C5.75 22.4002 5.41 22.7402 5 22.7402Z",
    fill: "#0C1525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeft);
export default __webpack_public_path__ + "static/media/align-left.673e2c80c325181ad2c14b0f6dbc6921.svg";
export { ForwardRef as ReactComponent };